import type { InjectionKey, Ref } from 'vue'

export type TabsContext = {
  value: Ref<string>
  onValueChange: (value: string) => void
}

export type TabListContext = {
  stretch: Ref<boolean>
}

export const TabsContextKey: InjectionKey<TabsContext> = Symbol('TabsContext')
export const TabListContextKey: InjectionKey<TabListContext> = Symbol('TabListContext')
